import React from "react";
import {Icon, Switch} from 'antd';

const BotPauseBotton = (props) => {
    const {
        paused, toggle
    } = props;

    return (
        <Switch checkedChildren={<div><Icon type="check"/> Bot Enabled</div>}
                unCheckedChildren={<div>Bot disabled<Icon type="cross"/></div>} checked={!paused} onChange={toggle}/>
    )
};

export default BotPauseBotton;


// WEBPACK FOOTER //
// ./src/components/admin/BotPauseButton.js